var map = {
	"./arabic.json": 788,
	"./bulgarian.json": 789,
	"./czech.json": 790,
	"./denmark.json": 791,
	"./english.json": 792,
	"./finnish.json": 793,
	"./greek.json": 794,
	"./indonesian.json": 795,
	"./malay.json": 796,
	"./norwegian.json": 797,
	"./romanian.json": 798,
	"./slovakia.json": 799,
	"./swedish.json": 800,
	"./thai.json": 801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2476;


//////////////////
// WEBPACK FOOTER
// ./src/locales/cutehub [A-Za-z0-9-_,\s]+\.json$/
// module id = 2476
// module chunks = 0